export default __webpack_public_path__ + "70756eab2c3c8eaa5fddc712d62807a3.png";